// * External
import { gql } from "lib/apolloClient";

// * Internal
import { studentDetailsFragment } from "Worksheet/modules/WorksheetFragments";

export const MONITORING_FRAGMENTS = {
  assignedStudent: gql`
    fragment assignedStudentItem on StudentAssignment {
      id
      assignment {
        id
        publishedAt
        timedTestDuration
        isFixedStartTime
        isTimedTestEnabled
        closeSubmissionDate
        isSafeBrowserEnabled
      }
      student {
        ...studentItem
        __typename
      }
      submission(showOnlySubmitted: $showOnlySubmitted) {
        id
        response
        endTime
        isPaused
        isLockScreenEnabled
        isOnScreenCalculatorEnabled
        questionSubmissions {
          totalQuestionCount
          totalQuestionAttempted
          edges {
            node {
              id
              isQuestionAttempted
              question {
                id
                questionType {
                  uid
                }
              }
              __typename
            }
          }
        }
        status
        statusV2
        submittedAt
        __typename
      }
      events(filters: $entityEventsFilter) {
        id
        eventType
        eventTime
        duration
        reason
        metadata
        __typename
      }
      __typename
    }
    ${studentDetailsFragment}
  `,
};

export const getWorksheetMonitoringQuery = gql`
  query getWorksheetMonitoringData(
    $id: ID!
    $studentIds: [ID!]
    $showOnlySubmitted: Boolean
    $entityEventsFilter: EntityEventsFilter
  ) {
    node(id: $id, type: ASSIGNMENT) {
      id
      ... on Assignment {
        ...assignmentItem
        __typename
      }
      __typename
    }
  }

  fragment assignmentItem on Assignment {
    id
    isOnScreenCalculatorEnabled
    isLockScreenEnabled
    isSafeBrowserEnabled
    content {
      id
      ... on Assessment {
        id
        questions {
          edges {
            id
            sequence
            parentIdV2
            parentTypeV2
            questionType {
              uid
            }
            questionTitleV2 {
              id
              uid
              value
            }
          }
        }
        __typename
      }
    }
    deadline
    counts {
      totalAssignedStudents
      totalSubmissions
    }
    assignedStudents(studentIds: $studentIds) {
      ...assignedStudentItem
      __typename
    }
    __typename
  }

  ${MONITORING_FRAGMENTS.assignedStudent}
`;
